import React from 'react';
import { useIntl } from 'react-intl';

import List from '@mui/material/List';
import Box from '@mui/material/Box';

import Button from '@ts-core/components/Button';

import GenericList from '@ts-core/core/components/GenericList';

import MessageNotificationItem from './MessageNotificationItem';

import { Message } from '../../types';

export interface MessageNotificationsListProps {
  messages?: Message[];
  selectedMessage?: Message;
  loading?: boolean;

  onViewMore?: () => void;
  onNotificationClick: (message: Message) => void;
}

const MessageNotificationsList = (props: MessageNotificationsListProps) => {
  const { messages, selectedMessage, loading = false, onViewMore, onNotificationClick } = props;
  const intl = useIntl();

  const isMessageSelected = (message?: Message) => message && message?.id === selectedMessage?.id;

  return (
    <List sx={{ bgcolor: 'background.paper' }}>
      <GenericList
        items={messages}
        skeletonsCount={3}
        loading={loading}
        renderItem={(index, message) => (
          <MessageNotificationItem
            key={index}
            message={message}
            selected={isMessageSelected(message)}
            loading={loading}
            onNotificationClick={onNotificationClick}
          />
        )}
      />
      {onViewMore && (
        <Box display="flex" alignItems="center" justifyContent="center" pt={1} width="100%" px={2}>
          <Button color="secondary" onClick={onViewMore} fullWidth>
            {intl.formatMessage({ id: 'notifications.view_details' })}
          </Button>
        </Box>
      )}
    </List>
  );
};

export default MessageNotificationsList;
